<template>
  <div id="app">
    <GeneratorSection></GeneratorSection>
  </div>
</template>

<script>
import GeneratorSection from './sections/GeneratorSection.vue'

export default {
  name: 'App',
  components: {
    GeneratorSection
  },
  methods: {
    // call listener at the first window blur or msec, whatever comes first
    addBlurListener (listener, msec) {
      const id = setTimeout(onBlur, msec)
      window.addEventListener('blur', onBlur)

      function onBlur () {
        clearTimeout(id)
        window.removeEventListener('blur', onBlur)
        listener()
      }

      return {
        stop () {
          clearTimeout(id)
          window.removeEventListener('blur', onBlur)
        }
      }
    }
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue